import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './App.jsx'
import './app.css'

const root = document.getElementById('root')
const app = <StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>

// Only the home page is prerendered (scripts/prerender.mjs); other routes start from an empty root.
if (root.hasChildNodes() && location.pathname === '/') hydrateRoot(root, app)
else createRoot(root).render(app)
